<ion-content>
    <div class="p-4">
        <div class="d-flex justify-content-end">
            <span class="bi bi-x fs-3 clickable" (click)="cancel()"></span>
        </div>
        <h1>{{ "Settings" | translate }}</h1>
        <app-locale-settings></app-locale-settings>
    </div>
</ion-content>
